import { SavingRateTrendTile } from "../SavingRateTrendTile.js";

export function SavingRateTrendWidget() {
  const today = new Date().toISOString().slice(0, 10);
  return <SavingRateTrendTile today={today} />;
}
